export default __webpack_public_path__ + "static/media/trash-can.f3d8acf0.svg";